import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const FraudField = (props) => {
  let { required, name, label, fieldlength, rows } = props;

  if (required === undefined) {
    required = false;
  }
  if (name === undefined) {
    name = "field";
  }
  if (label === undefined) {
    label = "Field";
  }
  if (fieldlength === undefined) {
    fieldlength = 5000;
  }
  if (rows === undefined) {
    rows = 2;
  }
  let value = name;
  if (name === "incidentdate") {
    value = "Incident Date";
  }

  if (name === "incidentplace") {
    value = "Incident Place";
  }
  if (name === "incidentdescr") {
    value = "Incident Description";
  }

  const isValid = (x) => {
    const re = /^[ "&-.0-:A-Za-z]{1,5000}$/;
    return (x || !required) &&
      (re.test(x) || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : "Enter a valid " + value;
  };

  return (
    <Field
      name={name}
      validate={isValid}
      required={required}
      label={label}
      autoComplete=""
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: fieldlength }}
      multiline={true}
      rows={rows}
    />
  );
};

export default FraudField;
